import { sendStripeSessionId } from 'api/coinApi';
import ThemeButton from 'components/NewHome/ThemeButton';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
interface PaymentSuccessPageProps {
    type: "success" | "cancel";
}

const PaymentSuccessPage: React.FC<PaymentSuccessPageProps> = ({ type }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const sessionId = searchParams.get('session_id');
    const pkg = searchParams.get('pkg');
    const [stripeResponse, setStripeResponse] = useState({ type: '', message: '' })
    const fetchSessionDetails = async () => {
        if (sessionId && pkg) {
            try {
                const result = await sendStripeSessionId(sessionId, pkg);
                if (result.status === "success") {
                    setStripeResponse({ type: result.status, message: result.message });
                }
            } catch (error: any) {
                console.error("Failed to fetch session details", error);
            }
        }
    };

    const handlePageNavigation = () => {
        stripeResponse.type === 'success' ? navigate('/feed') : navigate('/buy-coin');
    }

    useEffect(() => {
        if (type === 'cancel') {
            setStripeResponse({ type, message: 'Your payment has been canceled. Please try again or contact support if you need help.' })
        }
    }, []);

    useEffect(() => {
        fetchSessionDetails();
    }, [sessionId, pkg]);

    return (<>
        {stripeResponse.message && <div className='text-center shadow-md mt-10 min-w-[400px] w-[800px] mx-auto p-3'>
            <div className='mb-5'>
                <p className='text-base font-medium'>{stripeResponse.message}</p>
            </div>
            <ThemeButton
                bgColor="bg-primaryColor"
                textColor="text-white"
                padding="px-3 py-2"
                size="text-sm"
                rounded="rounded-full"
                className="font-medium mt-2"
                onClick={handlePageNavigation}
            >
                { stripeResponse.type === 'success' ? 'Go To Feed' : 'Buy Coin' }
            </ThemeButton>
        </div> }
    </>)
}
export default PaymentSuccessPage;